module.exports = __webpack_public_path__ + "img/man_1_2.af8e35c3.png";